import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const photos = [
  { src: "/images/gal-trail.jpg", caption: "Rhododendron trail, Sari to Deoria Taal" },
  { src: "/images/gal-circle.jpg", caption: "Evening sharing circle by the lake" },
  { src: "/images/deoria-yoga.jpg", caption: "Sunrise practice, Chaukhamba watching" },
  { src: "/images/gal-chai.jpg", caption: "First chai on the ridge" },
  { src: "/images/deoria-tungnath.jpg", caption: "Tungnath, 3,680 m" },
  { src: "/images/gal-summit.jpg", caption: "Chandrashila at dawn" },
  { src: "/images/deoria-camp.jpg", caption: "Camp under the Milky Way" },
];

export const TripGallery = () => {
  const strip = useRef(null);
  const slide = (dir) => strip.current?.scrollBy({ left: dir * Math.round(strip.current.clientWidth * 0.8), behavior: "smooth" });

  return (
    <section className="dt-gal" data-testid="deoria-gallery">
      <div className="dt-gal-head">
        <div>
          <p className="dt-kicker">From past treks & circles</p>
          <h2>Moments we keep</h2>
        </div>
        <div className="dt-gal-nav">
          <button type="button" onClick={() => slide(-1)} aria-label="Previous photos" data-testid="deoria-gallery-prev"><ChevronLeft size={20} /></button>
          <button type="button" onClick={() => slide(1)} aria-label="Next photos" data-testid="deoria-gallery-next"><ChevronRight size={20} /></button>
        </div>
      </div>
      <div className="dt-gal-strip" ref={strip} data-testid="deoria-gallery-strip">
        {photos.map((p, i) => (
          <figure key={p.src} className={`dt-gal-item ${i % 3 === 1 ? "is-tall" : ""}`}>
            <img src={p.src} alt={p.caption} loading="lazy" />
            <figcaption>{p.caption}</figcaption>
          </figure>
        ))}
      </div>
      <p className="dt-gal-hint">Swipe or drag to see more</p>
    </section>
  );
};
